import axios from '@axios'

const route = 'register/card'

export default {
  namespaced: true,
  state: {
    cards: [],
  },
  getters: {
    getCards(state) {
      return state.cards
    },
  },
  mutations: {
    setCards(state, cards) {
      state.cards = cards
    },
  },
  actions: {
    getAll(context, {
      itemsPerPage, page, search, filters,
    }) {
      return axios.post(`${route}/index?page=${page}&items_per_page=${itemsPerPage}`, filters)
    },

    store(context, card) {
      return axios.post(route, card)
    },

    update(context, card) {
      return axios.put(`${route}/${card.id}`, card)
    },

    destroy(context, card) {
      return axios.delete(`${route}/${card.id}`)
    },
  },
}
